import React, { FC, useCallback, useState } from 'react';
import SwiperCore, { Navigation, Thumbs, Pagination } from 'swiper';
import { NavigationOptions } from 'swiper/types/components/navigation';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';

import useScreenRecognition from 'hooks/useScreenRecognition';
import { LAYOUT_WRAPPER } from 'utils/constants';

import MainSlider from 'components/ProductCarousel/MainSlider';
import SecondarySlider from 'components/ProductCarousel/SecondarySlider';

import './ProductCarousel.scss';
import { IPropsProductCarousel } from './models';

SwiperCore.use([Navigation, Thumbs, Pagination]);
const LimitForControls = {
  mobile: 1,
  desktop: 3,
  lessLayoutWrapper: 3,
};
/**
 * LimitForControls.desktop should be 4 according to the design,
 * but we can center items in SecondarySlider on click only with odd number
 */
const ArrowPadding = 60;

const ProductCarousel: FC<IPropsProductCarousel> = ({
  items,
  isFirstViewport,
  dir,
  ariaLabelNext,
  ariaLabelPrev,
  generalImageAlt,
}) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore | null>(null);

  const { windowWidth, isMobile } = useScreenRecognition();
  const navPrevRef = React.useRef<HTMLButtonElement>(null);
  const navNextRef = React.useRef<HTMLButtonElement>(null);

  const onBeforeInitHandler = useCallback((swiper: SwiperCore): void => {
    const navigation = swiper.params.navigation as NavigationOptions;
    navigation.prevEl = navPrevRef.current;
    navigation.nextEl = navNextRef.current;
  }, []);

  const onSwiperHandler = useCallback((swiper: SwiperCore): void => {
    setThumbsSwiper(swiper);
  }, []);

  const isSmallWidth = LAYOUT_WRAPPER + ArrowPadding > windowWidth;
  const slidesInControlsDesktop = isSmallWidth
    ? LimitForControls.lessLayoutWrapper
    : LimitForControls.desktop;
  const slidesInControls = isMobile ? LimitForControls.mobile : slidesInControlsDesktop;
  const isShowControls = items.length > slidesInControls;

  if (!items?.length) {
    return null;
  }

  return (
    <div data-test="ProductCarousel" className="product-carousel">
      <MainSlider items={items} thumbsSwiper={thumbsSwiper} generalImageAlt={generalImageAlt} />
      {items.length > 1 ? (
        <SecondarySlider
          items={items}
          slidesInControls={slidesInControls}
          isFirstViewport={isFirstViewport}
          onSwiperHandler={onSwiperHandler}
          onBeforeInitHandler={onBeforeInitHandler}
          dir={dir}
          isMobile={isMobile}
          isShowControls={isShowControls}
          ariaLabelPrev={ariaLabelPrev}
          ariaLabelNext={ariaLabelNext}
          navPrevRef={navPrevRef}
          navNextRef={navNextRef}
          generalImageAlt={generalImageAlt}
        />
      ) : null}
    </div>
  );
};

export default ProductCarousel;
